export default class {
  constructor(options = {}) {
    this.currentIndex = 1;
    this.itemsWrapperSelector = document.querySelector(`${options.itemsWrapperSelector}`);
    this.buttonsWrapperSelector = document.querySelector(`${options.buttonsWrapperSelector}`);
    this.maxItemsPerPages = options.maxItemsPerPages || 16;
    this.minPage = options.minPage || 1;
    this.maxPage = options.maxPage || 3;
    this.numberOfPages = Math.ceil(
      this.itemsWrapperSelector.children.length / this.maxItemsPerPages
    );

    this.init();
  }

  init() {
    this.resetPagination();

    this.handlePaginationButtons();

    this.showPageItems();

  }


  handlePaginationButtons() {

    this.addPaginationButton('', this.currentIndex - 1);

    this.addPreviousBtn();

    this.addVisibleButtons();

    this.addNextBtn();

    this.addPaginationButton('', this.currentIndex + 1);


  }

  showPageItems() {
    for (
      let i =
        this.currentIndex * this.maxItemsPerPages - this.maxItemsPerPages;
      i < this.currentIndex * this.maxItemsPerPages;
      i++
    ) {
      if (this.itemsWrapperSelector.children[i]) {
        this.itemsWrapperSelector.children[i].style.display = 'block';
      }
    }
  }

  addVisibleButtons() {
    // buttons within the minPage and maxPage range !

    let pagination = this.currentIndex;
    if (this.currentIndex > 1) {
      pagination = this.currentIndex - 1;
    }

    let i = 0;
    for (let index = pagination; index <= this.numberOfPages; index++) {
      if (i < this.maxPage) {
        let button = this.addPaginationButton(index, index);
        console.log(button)

        if (index == this.currentIndex) {
          button.classList.add('active');
        }

        i = i + 1;
      }
    }
  }

  addBeginningBtn() {
    if (this.currentIndex - 1 > this.minPage) {
      this.addPaginationButton('...', 1);
    }
  }

  addLastBtn() {
    if (this.currentIndex + 1 < this.numberOfPages) {
      this.addPaginationButton('...', this.numberOfPages);
    }
  }

  addPreviousBtn() {
    this.addPaginationButton('Précédent', this.currentIndex - 1, 'previous')
  }
  addNextBtn() {
    this.addPaginationButton('Suivant', this.currentIndex + 1, 'next')
  }

  addPaginationButton(text, index, className = '') {
    let button = document.createElement('div');
    button.setAttribute('class', `pagination-item ${className}`);
    button.setAttribute('data-controls', index);

    let link = document.createElement('span');
    link.setAttribute('class', 'pagination-link');
    link.textContent = text;

    this.buttonsWrapperSelector.append(button);
    button.append(link);


    button.addEventListener('click', () => {
      this.setPaginationTo(button.getAttribute('data-controls'));
      this.init();
    });
    return button;
  }

  setPaginationTo(index) {
    if (
      index >= this.minPage &&
      index <= this.numberOfPages &&
      index != this.currentIndex
    ) {
      this.currentIndex = parseInt(index);
    }
  }

  resetPagination() {
    Array.from(this.itemsWrapperSelector.children).forEach(function (item) {
      item.style.display = 'none';
    });

    this.buttonsWrapperSelector.innerHTML = '';
  }
}


// WEBPACK FOOTER //
// ./scripts/module/pagination.js